(ns iris.logs.views.activity
  (:require
   [clojure.string :as string]
   [re-frame.core :as re-frame]
   [reagent.core :as r]
   [iris.logs.subs :as logs-subs]
   [iris.hench :as hench]
   [iris.subs :as subs]
   [shadow.css :refer [css]]))


(defn activity-btns
  ([ruid] (activity-btns ruid {}))
  ([ruid {:keys [activities]
          :or   {activities ["all" "post" "screen" "view" "admin"]}}]
   (let [query-params @(re-frame/subscribe [::subs/query-params])
         url-activity (get query-params :activity "all")
         base-path   (.-pathname js/window.location)]
     [:ul
      {:class "nav nav-pills logs-activity-pills" :style {:float "right"}}
      (for [a activities]
        [:li
         {:key  a
          :role "presentation"
          :class (when (= a url-activity) "active")}
         [:a {:href (if (= a "all")
                          base-path
                          (str base-path "?activity=" a))}
          (string/capitalize a)]])])))


(defn- eid-cell [eid raid-len]
  ;; eid is a full eid string like "f:aodta3j..."
  (if eid
    [:td [:a {:href (str "/logs/eid/" eid)} (hench/eid-len-raid eid raid-len)]]
    [:td]))

(defn- post-log-cell [ruid]
  (if ruid
    [:td [:a {:href (str "/logs/p/" ruid)} ruid]]
    [:td]))

(defn- board-cell [board-ruid]
  ;; board-ruid is like "/acme.TLO" — link to /logs/acme.TLO
  (if board-ruid
    [:td [:a {:href (str "/logs" board-ruid)} board-ruid]]
    [:td]))

(defn- ruid-cell [ruid]
  ;; Routes based on ruid prefix:
  ;;   "?xxx"  → /screening/xxx  (screening record)
  ;;   "@xxx"  → /logs/p/@xxx   (post)
  ;;   "/xxx"  → /logs/xxx      (board / header path)
  ;;   other   → plain text
  (if ruid
    (let [ch (first ruid)]
      [:td
       (cond
         (= ch \?) [:a {:href (str "/screening/" (subs ruid 1))} ruid]
         (= ch \@) [:a {:href (str "/logs/p/" ruid)} ruid]
         (= ch \/) [:a {:href (str "/logs" ruid)} ruid]
         :else ruid)])
    [:td]))

(defn- ip-cell [ip-ruid i-eid raid-len]
  ;; Display the IP eid when available, but keep the IP dashboard link keyed by ip_ruid.
  (if ip-ruid
    (let [ip      (subs ip-ruid 1)
          display (if i-eid (hench/eid-len-raid i-eid raid-len) ip-ruid)]
      [:td [:a {:href (str "/logs/ip/" ip)} display]])
    [:td]))

(defn- uid-cell [uid-ruid]
  ;; uid-ruid is "=username" or "==username" — strip all leading "=" and link to /logs/user/
  (if uid-ruid
    (let [uid (string/replace uid-ruid #"^=+" "")]
      [:td [:a {:href (str "/logs/user/" uid)} uid]])
    [:td]))

(defn- format-time [iso]
  ;; show abbreviated time, full ISO in title for tooltip
  (when iso
    (let [d (js/Date. iso)]
      (.toUTCString d))))


(defn activity-table []
  (let [events     @(re-frame/subscribe [::logs-subs/events])
        panel-kind @(re-frame/subscribe [::logs-subs/panel-kind])
        raid-len   @(re-frame/subscribe [::subs/raid-len])]
    [:div.table-responsive
      [:table
      {:class "table table-striped table-hover"}
      [:thead
        [:tr
        [:th "When (UTC)"]
        (when-not (= panel-kind :post) [:th "Forum"])
        [:th "Action"]
        (when-not (= panel-kind :post) [:th {:title "Resource Unique ID"} "Ruid"])
        [:th {:title "Auxiliary ID"} "Aux"]
        [:th {:title "IP address"} "IP"]
        [:th "Cookie"]
        [:th {:title "Browser Fingerprint"} "BFP"]
        [:th {:title "Device Fingerprint"} "DFP"]
        [:th "User"]]]
      [:tbody
        (if (empty? events)
          [:tr [:td {:col-span 10} "No events."]]
          (for [ev events]
            [:tr {:key (:time ev)}
            [:td {:title (:time ev)} (format-time (:time ev))]
            ;; Forum/Ruid cols hidden on post panel — every row already belongs to that one post
            (when-not (= panel-kind :post) (board-cell (:board_ruid ev)))
            [:td (:action ev)]
            (when-not (= panel-kind :post) (ruid-cell (:ruid ev)))
            (ruid-cell (:aux_ruid ev))
            (ip-cell (:ip_ruid ev) (:i_eid ev) raid-len)
            (eid-cell (:c_eid ev) raid-len)
            (eid-cell (:f_eid ev) raid-len)
            (eid-cell (:d_eid ev) raid-len)
            (uid-cell (:uid_ruid ev))]))]]]))
